module.exports = __webpack_public_path__ + "img/chess-pawn-piece.d0d8cd25.svg";